// Format a full LPID to have - in-between FlockCode, Drop, AnimalID

export const formatAnimalId = (fullAnimalId: string) => {
  if (fullAnimalId) {
    const flockCode: String = fullAnimalId.substring(0, 6);
    const drop: String = fullAnimalId.substring(6, 10);
    const animalId: String = fullAnimalId.substring(10);
    return `${flockCode}-${drop}-${animalId}`;
  }
  return 'Unavailable';
};
